import { useEffect, useState } from 'react';
import { api } from '../lib/api';
import { AmbassadorDashboard, type PartnerPageData } from '../PartnerPage';

/** The Brand Ambassador page inside the app (#721), for an account whose email is an ambassador's. */
export function AmbassadorAccount() {
  const [data, setData] = useState<PartnerPageData | null>(null);
  const [error, setError] = useState('');
  useEffect(() => {
    api
      .get<PartnerPageData>('/api/me/ambassador')
      .then(setData)
      .catch((e) => setError((e as Error).message));
  }, []);
  if (error) return <p className="error">{error}</p>;
  if (!data) return <p className="muted">Loading…</p>;
  return (
    <div className="partner-page in-app stack">
      <AmbassadorDashboard data={data} inApp stripeApi="/api/me/ambassador/stripe" />
    </div>
  );
}
